var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path, _path2, _ellipse, _path3, _polygon6, _path4, _path5, _path6, _path7, _path8, _polygon7, _polygon8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _g, _path90, _ellipse2, _path91, _path92, _ellipse3, _ellipse4, _path93, _path94, _polygon9, _path95, _path96, _ellipse5, _polygon10, _path97, _path98, _line, _ellipse6, _path99, _path100, _line2, _line3, _line4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 443.05 458.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -361,
    y1: -6080.25,
    x2: -361,
    y2: -5942,
    gradientTransform: "matrix(0.87, 0.5, 0, -1.15, 572.17, -6594.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 303.7,
    y1: -3837.61,
    x2: 303.7,
    y2: -3750.52,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -3592.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fafbfe",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#eaf0fb",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d0ddf7",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#acc4f1",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7da2e9",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#447ae0",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024bd5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "253.65 412.9 331.65 458.1 443.05 394.3 365.55 349.1 253.65 412.9",
    fill: "#4f7ce0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "254.05 402.4 262.65 401.4 347.85 445.5 331.45 455.9 254.55 412.3 254.05 402.4",
    fill: "#e2e2e2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "254.05 402.4 347.55 437.6 331.15 448 254.05 404.1 254.05 402.4",
    fill: "#bcbcbc"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "252.45 402.6 330.45 446.1 442.75 381.6 363.85 337.1 252.45 402.6",
    fill: "#4f7ce0"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "331.65 458.1 443.05 394.3 442.75 381.6 330.85 445.5 331.65 458.1",
    fill: "#466ac6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400.85,216.7a116.22,116.22,0,0,0-19.7-23.7s5.9,14.3,4.6,36.4,11.3,19.6,11.3,19.6Z",
    fill: "#406d06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M379.05,268.4s.2-10.2,22.9-10.2,23.8,10.2,23.8,10.2v40.5s-6,10.6-21.8,10.6a34.76,34.76,0,0,1-24.9-10.5Z",
    fill: "#ededed"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 402.35,
    cy: 268.2,
    rx: 23,
    ry: 9.7,
    fill: "#dbdcf0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M367,293.9,160.15,174.6c-2.9-1.7-5.2-6.2-5.2-10V4.6c0-3.9,2.4-5.6,5.2-4L366.85,120c2.9,1.7,5.2,6.2,5.2,10V289.9C372.15,293.7,369.85,295.6,367,293.9Z",
    fill: "#b1b4c4"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "368.05 295.6 370.25 294.1 369.25 287.5 368.05 295.6",
    fill: "#b1b4c4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.55,1.6l2.2-1.3L160,2.2l-3.5.5C156.55,2.7,154.55,1.6,154.55,1.6Z",
    fill: "#b1b4c4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M365.05,295,158.25,175.7c-2.9-1.7-5.2-6.2-5.2-10V5.7c0-3.9,2.4-5.6,5.2-4l206.8,119.4c2.9,1.7,5.2,6.2,5.2,10V291C370.25,294.9,368,296.6,365.05,295Z",
    fill: "#e4e7f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M364.65,295.1,158,175.9c-2.9-1.7-5.2-6.2-5.2-10V5.9c0-3.9,2.4-5.7,5.2-4l206.7,119.4c2.9,1.7,5.2,6.2,5.2,10V291.2C370,295.1,367.55,296.9,364.65,295.1Z",
    fill: "#d6d8e5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M367.05,285.5,155.25,163.2l.2-156.7c0-1.6,1.1-2.3,2.5-1.5l206.7,119.4a5.6,5.6,0,0,1,2.5,4.4l-.1,156.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M364.05,288.6,152.15,166.5l.1-156.7c0-1.6,1.1-2.2,2.5-1.5l206.7,119.4a5.6,5.6,0,0,1,2.5,4.4l.1,156.5Z",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.65,388.1,2,268.7c-2.9-1.7-2.5-4.6.8-6.5l138.5-79.9c3.4-1.9,8.4-2.1,11.3-.5l206.7,119.3c2.9,1.7,2.5,4.6-.8,6.5L220,387.6A12.56,12.56,0,0,1,208.65,388.1Z",
    fill: "#d6d8e5",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M213.25,385.4,6.45,266.1c-2.9-1.7-2.5-4.6.8-6.5l138.5-80c3.3-1.9,8.4-2.1,11.3-.5l206.8,119.4c2.9,1.7,2.5,4.6-.8,6.5l-138.5,80C221.15,386.9,216.15,387.1,213.25,385.4Z",
    fill: "#b1b4c4"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "4.65 263.4 4.65 259.5 8.95 261.3 4.65 263.4",
    fill: "#b1b4c4"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "365.85 301.4 365.85 297.6 362.55 298.6 364.65 301.9 365.85 301.4",
    fill: "#b1b4c4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M213.25,382.1,6.45,262.7c-2.9-1.7-2.5-4.6.8-6.5l138.5-80c3.3-1.9,8.4-2.1,11.3-.5l206.7,119.4c2.9,1.7,2.5,4.6-.8,6.5l-138.4,79.9C221.15,383.6,216.15,383.7,213.25,382.1Z",
    fill: "#e4e7f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M213.25,381.6,6.45,262.3c-2.9-1.7-2.5-4.6.8-6.5l138.5-80c3.3-1.9,8.4-2.1,11.3-.5l206.7,119.4c2.9,1.7,2.5,4.6-.8,6.5l-138.5,80C221.15,383.1,216.15,383.3,213.25,381.6Z",
    fill: "#d6d8e5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.05,202.7l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.4.7,1.2-.2,1.8l-9.2,5.3A3.74,3.74,0,0,1,142.05,202.7Z",
    fill: "#2b303f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M155.55,210.6,146,205c-.8-.4-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.37,3.37,0,0,1,155.55,210.6Z",
    fill: "#2b303f"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M169.45,218.6l-9.7-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.19,3.19,0,0,1,169.45,218.6Z",
    fill: "#2b303f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M183,226.4l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.4.7,1.2-.2,1.8l-9.2,5.3A4.71,4.71,0,0,1,183,226.4Z",
    fill: "#2b303f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M196.55,234.1l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.13,3.13,0,0,1,196.55,234.1Z",
    fill: "#2b303f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M210.05,242.1l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.39,3.39,0,0,1,210.05,242.1Z",
    fill: "#2b303f"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M223.65,250l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.7,3.7,0,0,1,223.65,250Z",
    fill: "#2b303f"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M237.45,257.7l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.12,3.12,0,0,1,237.45,257.7Z",
    fill: "#2b303f"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M251.05,265.6l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.39,3.39,0,0,1,251.05,265.6Z",
    fill: "#2b303f"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M264.55,273.6,255,268c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.37,3.37,0,0,1,264.55,273.6Z",
    fill: "#2b303f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M278.25,281.4l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.73,3.73,0,0,1,278.25,281.4Z",
    fill: "#2b303f"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M292,289.3l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A4.71,4.71,0,0,1,292,289.3Z",
    fill: "#2b303f"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M305.55,297.1l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A2.92,2.92,0,0,1,305.55,297.1Z",
    fill: "#2b303f"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M325.65,308.7l-16.2-9.4c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l16.2,9.4c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.1,3.1,0,0,1,325.65,308.7Z",
    fill: "#2b303f"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M149.05,222.1l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.43,3.43,0,0,1,149.05,222.1Z",
    fill: "#2b303f"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M162.65,229.9l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.12,3.12,0,0,1,162.65,229.9Z",
    fill: "#2b303f"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M176.25,237.7l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.39,3.39,0,0,1,176.25,237.7Z",
    fill: "#2b303f"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M190.05,245.6l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.38,3.38,0,0,1,190.05,245.6Z",
    fill: "#2b303f"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M203.55,253.5l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.15,3.15,0,0,1,203.55,253.5Z",
    fill: "#2b303f"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M217.05,261.4l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A4.69,4.69,0,0,1,217.05,261.4Z",
    fill: "#2b303f"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M230.85,269.3l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A4.71,4.71,0,0,1,230.85,269.3Z",
    fill: "#2b303f"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M244.45,277.1l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.12,3.12,0,0,1,244.45,277.1Z",
    fill: "#2b303f"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M258.05,285l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.73,3.73,0,0,1,258.05,285Z",
    fill: "#2b303f"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M271.65,292.9l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.72,3.72,0,0,1,271.65,292.9Z",
    fill: "#2b303f"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M285.45,300.7l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A4.15,4.15,0,0,1,285.45,300.7Z",
    fill: "#2b303f"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M299.05,308.6l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.12,3.12,0,0,1,299.05,308.6Z",
    fill: "#2b303f"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M135.45,214.1l-16.2-9.3c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l16.2,9.3c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.13,3.13,0,0,1,135.45,214.1Z",
    fill: "#2b303f"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M325.05,309.4l-9.6-5.5a3,3,0,0,0-2.9,0l-9.7,5.5a.78.78,0,0,0-.5,1.1c.1.3.3.5.5.5l.8.4a.83.83,0,0,1,.5,1,1.21,1.21,0,0,1-.5.5l-10.3,5.9c-.8.5-.8,1.2,0,1.6l6.1,3.5a3,3,0,0,0,2.9,0l9.6-5.5,2-1.1,1.4-.8,1.4-.8,8.3-4.8C325.85,310.5,325.85,309.7,325.05,309.4Z",
    fill: "#2b303f"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M89.15,233.3l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A4.12,4.12,0,0,1,89.15,233.3Z",
    fill: "#2b303f"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M102.85,241.1l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8L106,241A3.4,3.4,0,0,1,102.85,241.1Z",
    fill: "#2b303f"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M116.45,249l-9.7-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.51,3.51,0,0,1,116.45,249Z",
    fill: "#2b303f"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M232.05,315.7l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A4.15,4.15,0,0,1,232.05,315.7Z",
    fill: "#2b303f"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M245.65,323.6l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.37,3.37,0,0,1,245.65,323.6Z",
    fill: "#2b303f"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M259.25,331.5l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.72,3.72,0,0,1,259.25,331.5Z",
    fill: "#2b303f"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M273,339.4l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A4.71,4.71,0,0,1,273,339.4Z",
    fill: "#2b303f"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M133.55,258.9l-13.1-7.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l13.1,7.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.74,3.74,0,0,1,133.55,258.9Z",
    fill: "#2b303f"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M218.55,308l-13.1-7.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l13.1,7.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.74,3.74,0,0,1,218.55,308Z",
    fill: "#2b303f"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M201.45,298.1l-64-36.9c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l64,37c.8.5.7,1.2-.2,1.8l-9.2,5.3A4.15,4.15,0,0,1,201.45,298.1Z",
    fill: "#2b303f"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M139.55,231.7l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.4.7,1.2-.2,1.8l-9.2,5.3A3.13,3.13,0,0,1,139.55,231.7Z",
    fill: "#2b303f"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M153.05,239.6l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.12,3.12,0,0,1,153.05,239.6Z",
    fill: "#2b303f"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M166.65,247.5l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.72,3.72,0,0,1,166.65,247.5Z",
    fill: "#2b303f"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M180.25,255.4l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A4.67,4.67,0,0,1,180.25,255.4Z",
    fill: "#2b303f"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M194.05,263.3l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A4.23,4.23,0,0,1,194.05,263.3Z",
    fill: "#2b303f"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M207.55,271.1l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.4,3.4,0,0,1,207.55,271.1Z",
    fill: "#2b303f"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M221.15,279l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.73,3.73,0,0,1,221.15,279Z",
    fill: "#2b303f"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M234.65,286.7l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.1,3.1,0,0,1,234.65,286.7Z",
    fill: "#2b303f"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M248.45,294.6l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A2.91,2.91,0,0,1,248.45,294.6Z",
    fill: "#2b303f"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M262.05,302.6l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.43,3.43,0,0,1,262.05,302.6Z",
    fill: "#2b303f"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M275.55,310.4l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A4.71,4.71,0,0,1,275.55,310.4Z",
    fill: "#2b303f"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M289.15,318.3l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.7,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A5,5,0,0,1,289.15,318.3Z",
    fill: "#2b303f"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M126,224l-19.9-11.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l19.9,11.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.73,3.73,0,0,1,126,224Z",
    fill: "#2b303f"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M119.55,235.6l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.73,3.73,0,0,1,119.55,235.6Z",
    fill: "#2b303f"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M133.15,243.4l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A4.73,4.73,0,0,1,133.15,243.4Z",
    fill: "#2b303f"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M146.65,251.3l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A4.67,4.67,0,0,1,146.65,251.3Z",
    fill: "#2b303f"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M160.45,259.1l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.4,3.4,0,0,1,160.45,259.1Z",
    fill: "#2b303f"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M174.05,267l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.74,3.74,0,0,1,174.05,267Z",
    fill: "#2b303f"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M187.55,274.7l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.12,3.12,0,0,1,187.55,274.7Z",
    fill: "#2b303f"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M201.15,282.6l-9.6-5.5c-.8-.5-.7-1.2.2-1.8L201,270a3.39,3.39,0,0,1,3.1-.1l9.6,5.5c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.12,3.12,0,0,1,201.15,282.6Z",
    fill: "#2b303f"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M214.85,290.6l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.73,3.73,0,0,1,214.85,290.6Z",
    fill: "#2b303f"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M228.45,298.4l-9.7-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A5.11,5.11,0,0,1,228.45,298.4Z",
    fill: "#2b303f"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M242.05,306.3l-9.6-5.5c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A5.45,5.45,0,0,1,242.05,306.3Z",
    fill: "#2b303f"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M255.55,314.1l-9.6-5.6c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l9.6,5.6c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.37,3.37,0,0,1,255.55,314.1Z",
    fill: "#2b303f"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M286.05,331.6l-26.5-15.3c-.8-.5-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l26.5,15.3c.8.5.7,1.2-.2,1.8l-9.2,5.3A3.12,3.12,0,0,1,286.05,331.6Z",
    fill: "#2b303f"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M106,227.6,92.85,220c-.8-.4-.7-1.2.2-1.8l9.2-5.3a3.39,3.39,0,0,1,3.1-.1l13.1,7.6c.8.4.7,1.2-.2,1.8l-9.2,5.3A3.11,3.11,0,0,1,106,227.6Z",
    fill: "#2b303f"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M339.45,300.9,146.05,189.4c-.8-.4-.7-1.2.2-1.8l4.6-2.6a3.39,3.39,0,0,1,3.1-.1l193.3,111.6c.8.5.7,1.2-.2,1.8l-4.6,2.6A3.5,3.5,0,0,1,339.45,300.9Z",
    fill: "#2b303f"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M219.55,313.6a3,3,0,0,1-1.3,1.4l-53.2,30.7a6.46,6.46,0,0,1-5.9.2l-90.9-52.5a2.19,2.19,0,0,1-.9-1c-.3-.8.1-1.7,1.3-2.4l53.2-30.7a6.46,6.46,0,0,1,5.9-.2l90.9,52.5A1.39,1.39,0,0,1,219.55,313.6Z",
    fill: "#b1b4c4"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M219.55,313.6a3,3,0,0,1-1.3,1.4l-53.2,30.7a6.46,6.46,0,0,1-5.9.2l-90.9-52.5a2.19,2.19,0,0,1-.9-1,2.37,2.37,0,0,1,1.3-1.3l53.2-30.7a6.46,6.46,0,0,1,5.9-.2l90.9,52.5C219.05,312.9,219.55,313.1,219.55,313.6Z",
    fill: "#c3c6d1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M354.05,292.5,160.85,180.9a3.19,3.19,0,0,1-1.4-2.7v-2.3c0-1.1.6-1.5,1.4-1.1l193.2,111.6a3.19,3.19,0,0,1,1.4,2.7v2.3C355.55,292.4,355,292.9,354.05,292.5Z",
    fill: "#2b303f"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M278.65,105.1l-19.4-11.6a2.61,2.61,0,0,1-1-2V86.9c0-.8.5-1.1,1-.8l19.4,11.6a2.61,2.61,0,0,1,1,2v4.7C279.65,105,279.25,105.4,278.65,105.1Z",
    fill: "#024bd5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M266.25,108.3l-7.1-4.2a2.61,2.61,0,0,1-1-2V97.5c0-.8.5-1.1,1-.8l7.1,4.2a2.61,2.61,0,0,1,1,2v4.7C267.25,108.3,266.85,108.6,266.25,108.3Z",
    fill: "#a2c5fc"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M349.55,141.4l-7.1-4.2a2.61,2.61,0,0,1-1-2v-4.6c0-.8.5-1.1,1-.8l7.1,4.2a2.61,2.61,0,0,1,1,2v4.7C350.55,141.3,350.05,141.7,349.55,141.4Z",
    fill: "#e9eaf2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M235.85,117.1l-64.2-37.2a2.58,2.58,0,0,1-1-1.9V75.7c0-.8.4-1.1,1-.8l64.2,37.2a2.61,2.61,0,0,1,1,2v2.3C236.85,117.1,236.45,117.5,235.85,117.1Z",
    fill: "#e9eaf2"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M235.85,107.7l-64.2-37.2a2.58,2.58,0,0,1-1-1.9V66.3c0-.8.4-1.1,1-.8l64.2,37.2a2.61,2.61,0,0,1,1,2V107C236.85,107.7,236.45,108.1,235.85,107.7Z",
    fill: "#e9eaf2"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M235.85,98.2,171.65,61a2.58,2.58,0,0,1-1-1.9V56.8c0-.8.4-1.1,1-.8l64.2,37.2a2.61,2.61,0,0,1,1,2v2.3C236.85,98.2,236.45,98.6,235.85,98.2Z",
    fill: "#e9eaf2"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M235.85,126.6l-64.2-37.2a2.42,2.42,0,0,1-1-1.9V85.2c0-.8.4-1.1,1-.8l64.2,37.2a2.58,2.58,0,0,1,1,1.9v2.3C236.85,126.5,236.45,126.9,235.85,126.6Z",
    fill: "#e9eaf2"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M235.85,135.4l-64.2-37.2a2.58,2.58,0,0,1-1-1.9V94c0-.8.4-1.1,1-.8l64.2,37.2a2.61,2.61,0,0,1,1,2v2.3C236.85,135.3,236.45,135.7,235.85,135.4Z",
    fill: "#e9eaf2"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M236,163.4l-64.2-37a2.58,2.58,0,0,1-1-1.9V108.3c0-.8.5-1.1,1-.8L236,144.6a2.58,2.58,0,0,1,1,1.9v16.1C237,163.4,236.45,163.8,236,163.4Z",
    fill: "#edeef4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M236,84.1l-64.2-37.4a2.58,2.58,0,0,1-1-1.9V36.1c0-.8.5-1.1,1-.8L236,72.8a2.58,2.58,0,0,1,1,1.9v8.6C237,84.1,236.45,84.5,236,84.1Z",
    fill: "#e9eaf2"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M236,185.8l-64.2-37a2.58,2.58,0,0,1-1-1.9V130.7c0-.8.5-1.1,1-.8L236,167a2.58,2.58,0,0,1,1,1.9V185C237,185.8,236.45,186.2,236,185.8Z",
    fill: "#edeef4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Men_4",
    "data-name": "Men 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.45,283.4s.9,13.2,2.6,15.1,7.6,3.2,7.6,3.2l4.5,7.5s-4.1-23.7-5-24.3S61.45,283.4,61.45,283.4Z",
    fill: "#ffcea9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 5",
    d: "M70.15,268.6a4.93,4.93,0,0,0-6.3,1.9c-1.7,2.8-3.4,12.2-3.6,13.8,0,0,2.3,3.2,5.8,2.8Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.45,400.9a9.3,9.3,0,0,0,7.3-.9c1.8,0,11.3-4.1,12.6-.6,1.1,3-3,5.8-5.2,6.3-4.8,1.2-8.4,3.6-10.4,4-1.4.3-3.3.5-4.5-.6C82.15,407.6,82.15,402.6,83.45,400.9Z",
    fill: "#38226d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,408.9c1.9-.4,5.5-2.8,10.4-4,1.9-.4,5-2.5,5.4-4.9.4,2.8-3.3,5.2-5.4,5.7-4.8,1.2-8.4,3.6-10.4,4-1.4.3-3.3.5-4.5-.6a2.28,2.28,0,0,1-.6-1.2A5.77,5.77,0,0,0,88,408.9Z",
    fill: "#9c73ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.65,396.1a9.3,9.3,0,0,0,7.3-.9c1.8,0,11.3-4,12.7-.6,1.1,3-3,5.8-5.2,6.3-4.8,1.2-8.4,3.6-10.4,4-1.5.3-3.3.5-4.5-.6C67.15,403.1,67.25,398,68.65,396.1Z",
    fill: "#38226d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.15,404.1c1.9-.4,5.5-2.8,10.4-4,1.9-.4,5.1-2.5,5.4-4.9.4,2.8-3.3,5.2-5.4,5.8-4.8,1.2-8.4,3.6-10.4,4-1.5.3-3.3.5-4.5-.6a2.28,2.28,0,0,1-.6-1.2A5.68,5.68,0,0,0,73.15,404.1Z",
    fill: "#9c73ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_6",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 6",
    d: "M67.65,369.3a61.18,61.18,0,0,1,2.2-10.5s-.7-9.1-1-17.6c-.4-9.7-3.7-18.3-1.1-26.1l29.6,6.6s-1.4,38.9-1.8,43.6a79.24,79.24,0,0,1-1.4,10.9c-1.4,7.5-2.9,24.4-2.9,24.4-3.2,1.9-7.8.3-7.8.3s0-21.1.2-26.5c.2-6.6.5-6.1.5-6.1l-1-16.5-.6-8.2s-.8,6-1.4,11.4c-.5,4.7-1.6,8.9-2.9,17.7-1.1,7.6-2.2,23-2.2,23-3.2,1.8-7.5.6-7.5.6S66.85,375.9,67.65,369.3Z",
    fill: "#024bd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_7",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 7",
    d: "M71.85,268.9c2.3.1,4,.7,4.3,0,.2-1.2.4-2.4.5-3.6a13.36,13.36,0,0,1-.5-1.4c-2.9-1.8-3.8-4.9-4.1-8.5-.6-6.2,2.8-11.6,8.9-12.2,5.8-.6,10.1,3.5,11.2,9.1.6,2.8,1.8,8,.2,12.6-.9,2.6-2.1,4.6-3.3,5a18.7,18.7,0,0,1-3.4-.3h0s-.3,1.7-.5,2.8-.1,1.7,2.1,3-3.3,4.1-6.9,3.9-7.7-2.4-8.8-4.8C70.15,271.9,70.15,268.7,71.85,268.9Z",
    fill: "#ffcea9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 8",
    d: "M75.15,269.1c-.6,1.6,1,3.5,5.3,4.9s4.7-.4,4.7-.4a93.3,93.3,0,0,1,8.3,4.3c2.6,1.8,3.7,7,4.1,15.8.4,10.2.4,25.3.1,27.9,0,0-4.8,4.8-11.1,4.3s-16.6-6-19.1-10.2c0-8.9,1.1-10.4-.3-15.5-3.3-11.8-5.1-16.6-3.4-24.4,1.4-6.5,3.2-7.3,5.7-7.2C71.25,268.7,73.15,268.9,75.15,269.1Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.15,329.6l-3.1-35.5,6.6-3.5,2.6,2.2-.9,31.9h0v.9h0v1.1s.1,2.7-4.9,5.9l-.2-1.6h0l-.1-1.4Z",
    fill: "#ffcea9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_9",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 9",
    d: "M91.45,275.7c3.4,0,5.5,1.7,6.4,7s1.4,9.6,1.4,9.6a9.62,9.62,0,0,1-6.1,3c-4.1.5-5.3-1.6-5.3-1.6s-.4-5.5-.7-9.2S87.15,275.9,91.45,275.7Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.85,251.5s5.3-8.1-6.2-9.8c-8.3-1.2-13.7,4.1-14.3,10-.6,5.5,2.8,11.3,5.3,13.6a10,10,0,0,0,7.2-.9c.1-1.5.2-3,.2-4.5C84,259.9,80,251.3,91.85,251.5Z",
    fill: "#002f87"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M34.65,117.7a12.16,12.16,0,0,1,3.2-8.3c4.3-4.8,13.4-11.6,30-11.6,17.7,0,26.5,8.4,30.2,13.6a12.34,12.34,0,0,1,2.3,7.2v55.2a12.75,12.75,0,0,1-3.3,8.5c-4.1,4.3-12.4,10-28.3,10-15.3,0-24.4-4.9-29.3-8.8a12.32,12.32,0,0,1-4.7-9.7l-.1-56.1Z",
    fill: "#ededed"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.45,
    cy: 118.7,
    rx: 30.9,
    ry: 17.7,
    fill: "#d6d8e5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M40.05,140.4l5.4,2.6v6.2s-9.6,4.2-9.9,13.3c-.3,12.1,9.9,12.1,9.9,12.1V181s-20.3-4.1-19.5-20.3C26.55,148.9,40.05,140.4,40.05,140.4Z",
    fill: "#ededed"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M45.55,143.1v5.2s-9.6,5.2-9.9,14.3c-.3,12.1,9.9,13.4,9.9,13.4v4.1s-13.9-1.8-13.2-18C32.85,150.2,45.55,143.1,45.55,143.1Z",
    fill: "#d6d8e5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.55,
    cy: 122,
    rx: 28.2,
    ry: 13.8,
    fill: "#68460f"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 402.05,
    cy: 270.4,
    rx: 21.1,
    ry: 7.1,
    fill: "#54360b"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M404.25,277c-.3,0-21.2,2.7-25.3-31.6s-9.1-49.7-9.1-49.7,20.1,25.2,24.3,42.6c0,0-.3-15.5,4.8-29.2,4.7-12.7,3.4-29.3,3.4-29.3s7.5,15.2,9.2,28.9c1.7,14.4-1.4,37.2,2.6,37.5,0,0-5-45,15.8-58.8,0,0-3.3,24-1.8,44.8S424.85,275.6,404.25,277Z",
    fill: "#238500"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M405.85,277.1s-17.8-1.6-7.2-26.6,15.4-35.8,15.4-35.8-3.5,16.1,3.7,35.4S410.05,278.4,405.85,277.1Z",
    fill: "#50992e"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "380.95 373 386.75 370.6 387.45 371.7 382.75 376.9 380.95 373",
    fill: "#d1c7d1"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M312.15,411.4,381,372.9s2.9.7,1.8,3.9l-67.3,39.5Z",
    fill: "#ffbd44"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M314.05,414.3l68.7-40a2.8,2.8,0,0,1,0,2.6l-67.3,39.4Z",
    fill: "#e8a436"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.94,
    cy: 413.81,
    rx: 1.6,
    ry: 2.9,
    transform: "translate(-146.34 173.11) rotate(-25.21)",
    fill: "#45457d"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "386.75 370.6 388.95 369.7 387.45 371.7 386.75 370.6",
    fill: "#002f87"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M257.55,163.6s7.4,6.2,18-2.3c7.6-6.2,14.4-2.7,18.2-.5s9.3,3.4,19.7,22.3a27,27,0,0,0,9,9.1c5.6,3.2,8.3,1.7,12.7-5s7.3-14,15.4-9.2v66.9l-93.7-54.2V163.2Z",
    fill: "url(#linear-gradient-2)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M256.65,163.2c16.6,10.3,19-13,37.1-2.5s15.6,24.1,29,31.8,13.7-22.5,27.7-14.4",
    fill: "none",
    stroke: "#024bd5",
    strokeMiterlimit: 10,
    strokeWidth: 1.09
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 293.55,
    y1: 122.7,
    x2: 293.55,
    y2: 212.1,
    fill: "none",
    stroke: "#20a1e2",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.67,
    cy: 161.19,
    rx: 1.8,
    ry: 3.1,
    transform: "translate(-41.25 168.43) rotate(-30)",
    fill: "#ffbd44"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M230.85,157.7l-11.2-6.7a2.61,2.61,0,0,1-1-2v-9.3c0-.8.5-1.1,1-.8l11.2,6.7a2.61,2.61,0,0,1,1,2V157C231.85,157.6,231.35,158,230.85,157.7Z",
    fill: "#d6d8e5"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M230.85,179.4l-11.2-6.7a2.61,2.61,0,0,1-1-2v-9.3c0-.8.5-1.1,1-.8l11.2,6.7a2.61,2.61,0,0,1,1,2v9.4C231.85,179.3,231.35,179.7,230.85,179.4Z",
    fill: "#d6d8e5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 350.55,
    y1: 176.9,
    x2: 349.65,
    y2: 176.4,
    fill: "none",
    stroke: "#939494",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 347.85,
    y1: 175.5,
    x2: 258.45,
    y2: 127.8,
    fill: "none",
    stroke: "#939494",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    strokeDasharray: "1.97 1.97"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 257.55,
    y1: 127.4,
    x2: 256.65,
    y2: 126.9,
    fill: "none",
    stroke: "#939494",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonImage);
export default __webpack_public_path__ + "static/media/PersonImage.73f03948.svg";
export { ForwardRef as ReactComponent };